import { render, staticRenderFns } from "./Expressions.vue?vue&type=template&id=2c20a2c6&scoped=true"
import script from "./Expressions.vue?vue&type=script&lang=js"
export * from "./Expressions.vue?vue&type=script&lang=js"
import style0 from "./Expressions.vue?vue&type=style&index=0&id=2c20a2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20a2c6",
  null
  
)

export default component.exports